module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/whatsapp-4936fb8a94148593afdb3dc1305ad7a7.png";